"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7597],{

/***/ 82896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var AllIn = function AllIn(_ref) {
  var url = _ref["static"].url;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    defer: true,
    fetchpriority: "low",
    src: url
  });
};
AllIn.ssr = true;
 false ? 0 : void 0;
AllIn.defaultProps = {
  "static": {
    url: 'https://i.btg360.com.br/btg360-2.0.1.min.js'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (AllIn);

/***/ }),

/***/ 64365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var AllInNewsletter = function AllInNewsletter(_ref) {
  var url = _ref["static"].url;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    defer: true,
    fetchpriority: "low",
    src: url
  });
};
AllInNewsletter.ssr = true;
 false ? 0 : void 0;
AllInNewsletter.defaultProps = {
  "static": {
    url: 'https://i.btg360.com.br/wf.js'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (AllInNewsletter);

/***/ }),

/***/ 14286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var Azion = function Azion() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    defer: true,
    fetchpriority: "low",
    src: "https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js"
  });
};
Azion.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (Azion);

/***/ }),

/***/ 94842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Bing = function Bing(_ref) {
  var tagId = _ref["static"].tagId;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      if(!window.uetq){\n        (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:\"".concat(tagId, "\", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push(\"pageLoad\")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!==\"loaded\"&&s!==\"complete\"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,\"script\",\"//bat.bing.com/bat.js\",\"uetq\");\n        }")
    }
  });
};
Bing.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Bing);

/***/ }),

/***/ 45875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6422);



var CookieSecurity = function CookieSecurity(_ref) {
  var structure = _ref.structure;
  var _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config;
  var logger = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .Logger */ .Yd)(config);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var cookieSecurityScript = document.getElementById('cookieSecurity');
    if (!cookieSecurityScript) {
      var script = document.createElement('script');
      script.id = 'cookieSecurity';
      script.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js';
      script.setAttribute('data-tenant-uuid', '7923f79c-dd89-44df-bbc4-cc5a1f904fbf');
      script.setAttribute('data-domain-uuid', '0b729802-6884-47fb-b13a-da5dc5874f35');
      script.setAttribute('data-backend-url', 'https://app.securiti.ai');
      script.setAttribute('data-skip-css', 'false');
      script.fetchPriority = 'low';
      script.defer = true;
      var parentNode = document.head || document.body;
      parentNode.appendChild(script);
      script.addEventListener('load', function () {
        window.initCmp();
      });
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      try {
        var externalScript = document.getElementById('cookieSecurity');
        if (externalScript) externalScript.remove();
        document.querySelectorAll('head > script[src*=securiti]').forEach(function (elem) {
          return elem.remove();
        });
        document.querySelectorAll('body > div[class^=cc-]').forEach(function (elem) {
          return elem.remove();
        });
      } catch (e) {
        logger.error(e);
      }
    };
  }, [structure.asPath]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null);
};
CookieSecurity.defaultProps = {
  structure: {}
};
CookieSecurity.propTypes = {
  structure: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({})
};
CookieSecurity.ssr = false;
/* harmony default export */ __webpack_exports__["default"] = (CookieSecurity);

/***/ }),

/***/ 63760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Criteo = function Criteo(_ref) {
  var url = _ref["static"].url;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    defer: true,
    fetchpriority: "low",
    src: url
  });
};
Criteo.ssr = true;
 false ? 0 : void 0;
Criteo.defaultProps = {
  "static": {
    url: 'https://static.criteo.net/js/ld/ld.js'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (Criteo);

/***/ }),

/***/ 64002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);



var Datadog = function Datadog(_ref) {
  var _serverConfig$datadog, _serverConfig$datadog2, _serverConfig$datadog3;
  var staticProps = _ref["static"];
  var clientToken = staticProps.clientToken,
    applicationId = staticProps.applicationId,
    service = staticProps.service,
    _staticProps$datadogU = staticProps.datadogUrl,
    datadogUrl = _staticProps$datadogU === void 0 ? 'us5.datadoghq.com' : _staticProps$datadogU,
    _staticProps$trackRes = staticProps.trackResources,
    trackResources = _staticProps$trackRes === void 0 ? true : _staticProps$trackRes,
    _staticProps$trackLon = staticProps.trackLongTasks,
    trackLongTasks = _staticProps$trackLon === void 0 ? true : _staticProps$trackLon,
    _staticProps$trackUse = staticProps.trackUserInteractions,
    trackUserInteractions = _staticProps$trackUse === void 0 ? true : _staticProps$trackUse,
    _staticProps$defaultP = staticProps.defaultPrivacyLevel,
    defaultPrivacyLevel = _staticProps$defaultP === void 0 ? 'mask-user-input' : _staticProps$defaultP;
  var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()(),
    config = _getConfig.publicRuntimeConfig,
    serverConfig = _getConfig.serverRuntimeConfig;
  if (!(serverConfig == null ? void 0 : (_serverConfig$datadog = serverConfig.datadog) == null ? void 0 : _serverConfig$datadog.enabled)) {
    return null;
  }
  var content = "\n    (function(h,o,u,n,d) {\n     h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n     d=o.createElement(u);d.async=1;d.src=n\n     n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n    })(window,document,'script','https://www.datadoghq-browser-agent.com/us5/v5/datadog-rum.js','DD_RUM')\n    window.DD_RUM.onReady(function() {\n      window.DD_RUM.init({\n        clientToken: '".concat(clientToken, "',\n        applicationId: '").concat(applicationId, "',\n        site: '").concat(datadogUrl, "',\n        service: '").concat(service, "',\n        env: '").concat(config.environment, "',\n        version: '").concat(config.appVersion, "',\n        sessionSampleRate: ").concat(serverConfig == null ? void 0 : (_serverConfig$datadog2 = serverConfig.datadog) == null ? void 0 : _serverConfig$datadog2.sessionSample, ",\n        sessionReplaySampleRate: ").concat(serverConfig == null ? void 0 : (_serverConfig$datadog3 = serverConfig.datadog) == null ? void 0 : _serverConfig$datadog3.sessionReplay, ",\n        trackResources: ").concat(trackResources, ",\n        trackLongTasks: ").concat(trackLongTasks, ",\n        trackUserInteractions: ").concat(trackUserInteractions, ",\n        defaultPrivacyLevel: '").concat(defaultPrivacyLevel, "',\n      });\n    })\n  ");
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    "data-testid": "datadog",
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};
Datadog.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Datadog);

/***/ }),

/***/ 53213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var Ebit = function Ebit() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    defer: true,
    id: "getSelo",
    fetchpriority: "low",
    src: "https://imgs.ebit.com.br/ebitBR/selo-ebit/js/getSelo.js?552"
  });
};
Ebit.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (Ebit);

/***/ }),

/***/ 80995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6422);


var _excluded = ["href", "rel"];



var Favicon = function Favicon(_ref) {
  var _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$icons = _ref$static2.icons,
    icons = _ref$static2$icons === void 0 ? [] : _ref$static2$icons;
  return icons == null ? void 0 : icons.map(function (_ref2) {
    var href = _ref2.href,
      rel = _ref2.rel,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, _excluded);
    return href && rel && react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
      key: "favicon-".concat((0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_2__/* .slug */ .oF)(rel)),
      rel: rel,
      href: href
    }, props));
  });
};
Favicon.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Favicon);

/***/ }),

/***/ 14499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);



var GoogleTagManagerHead = function GoogleTagManagerHead(_ref) {
  var id = _ref["static"].id;
  var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()(),
    config = _getConfig.publicRuntimeConfig;
  var DEV_MODE = config.environment === 'development';
  var setupContent = "\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({originalLocation: document.location.protocol+'//'+\n    document.location.hostname+document.location.pathname+document.location.search});\n    w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(id, "')\n  ");
  var setupDev = "(function (w, l) {w[l] = w[l] || [];})(window, 'dataLayer')";
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: DEV_MODE ? setupDev : setupContent
    }
  });
};
GoogleTagManagerHead.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (GoogleTagManagerHead);

/***/ }),

/***/ 59462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var GoogleTagManagerNoscript = function GoogleTagManagerNoscript(_ref) {
  var id = _ref["static"].id;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: "<noscript><iframe src=\"https://www.googletagmanager.com/ns.html?id=".concat(id, "\" width=\"0\" heigth=\"0\" style=\"display:none;visibility:hidden\"></iframe></noscript>")
    }
  });
};
GoogleTagManagerNoscript.ssr = true;
GoogleTagManagerNoscript.displayName = 'GoogleTagManagerNoscript';
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (GoogleTagManagerNoscript);

/***/ }),

/***/ 61220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Hotjar = function Hotjar(_ref) {
  var id = _ref["static"].id;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      (function(h,o,t,j,a,r){\n        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n        h._hjSettings={hjid:".concat(id, ",hjsv:6};\n        a=o.getElementsByTagName('head')[0];\n        r=o.createElement('script');r.async=1;r.fetchPriority=\"low\";\n        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n        a.appendChild(r);\n    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');")
    }
  });
};
Hotjar.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Hotjar);

/***/ }),

/***/ 70007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ JsonLd_JsonLd; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js + 1 modules
var JsonLD = __webpack_require__(66228);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/index.js + 11 modules
var schemas = __webpack_require__(93088);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/JsonLd/JsonLd.js


var _excluded = ["type"];




var JsonLd = function JsonLd(_ref) {
  var _data$questions2;
  var data = _ref.data,
    _ref$static = _ref["static"],
    type = _ref$static.type,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded),
    structure = _ref.structure;
  var product = data.product,
    productRating = data.productRating;
  var config = structure.config;
  var jsonProps = function jsonProps(t) {
    var _data$questions;
    switch (t) {
      case 'Product':
        return (0,schemas/* productSchema */.Iy)({
          product: (0,esm_extends/* default */.Z)({}, product, {
            title: product == null ? void 0 : product.title
          }),
          productRating: productRating
        }, "".concat(config == null ? void 0 : config.domain, "/"));
      case 'FAQPage':
        return (0,schemas/* faqSchema */.I1)((data == null ? void 0 : (_data$questions = data.questions) == null ? void 0 : _data$questions.items) || []);
      default:
        return (0,esm_extends/* default */.Z)({}, props);
    }
  };
  var notReturnEmptyFaq = !!(type === 'FAQPage' && !(data == null ? void 0 : (_data$questions2 = data.questions) == null ? void 0 : _data$questions2.items.length));
  return notReturnEmptyFaq ? null : react.createElement(JsonLD/* default */.ZP, {
    type: type,
    schema: jsonProps(type)
  });
};
 false ? 0 : void 0;
JsonLd.defaultProps = {
  data: {},
  structure: {}
};
JsonLd.ssr = true;
/* harmony default export */ var JsonLd_JsonLd = (JsonLd);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/JsonLd/index.js


/***/ }),

/***/ 42438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Preconnect = function Preconnect(_ref) {
  var _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$list = _ref$static2.list,
    list = _ref$static2$list === void 0 ? [] : _ref$static2$list;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, list.map(function (item) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      key: "preconnect-".concat(item),
      rel: "preconnect",
      href: item,
      crossOrigin: "true",
      defer: true
    });
  }));
};
Preconnect.defaultProps = {
  "static": {
    list: []
  }
};
 false ? 0 : void 0;
Preconnect.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (Preconnect);

/***/ }),

/***/ 50682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var RTBHouse = function RTBHouse() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      (function (w,d,dn,t){w[dn]=w[dn]||[];w[dn].push({eventType:'init',value:t,dc:'us'});\n      var f=d.getElementsByTagName('script')[0],\n      c=d.createElement('script');\n      c.async=true;\n      c.fetchPriority=\"low\";\n      c.src='https://tags.creativecdn.com/msWukR4UlwKQouZSY8IT.js';\n      f.parentNode.insertBefore(c,f);})(window,document,'rtbhEvents','msWukR4UlwKQouZSY8IT');\n      "
    }
  });
};
RTBHouse.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (RTBHouse);

/***/ }),

/***/ 65027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var Radware = function Radware() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    id: "radware",
    dangerouslySetInnerHTML: {
      __html: "(function (w, d, e, u, c, g, a, b) {\n        w['SSJSConnectorObj'] = w['SSJSConnectorObj'] || {\n          ss_cid: c,\n          domain_info: 'auto',\n        };\n        w[g] = function (i, j) {\n          w['SSJSConnectorObj'][i] = j;\n        };\n        a = d.createElement(e);\n        a.async = true;\n        a.fetchPriority = \"low\";\n        a.src = u;\n        b = d.getElementsByTagName(e)[0];\n        b.parentNode.insertBefore(a, b);\n      })(\n        window,\n        document,\n        'script',\n        'https://cdn.perfdrive.com/aperture/aperture.js',\n        'bna1',\n        'ssConf'\n      );\n      ssConf('c1', 'https://cas.avalon.perfdrive.com');"
    }
  });
};
Radware.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (Radware);

/***/ }),

/***/ 9039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var ReclameAqui = function ReclameAqui() {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    defer: true,
    fetchpriority: "low",
    id: "ra-embed-reputation",
    src: "https://s3.amazonaws.com/raichu-beta/selos/bundle.js",
    "data-id": "MjkyNjY6bWFnYXppbmUtbHVpemEtbG9qYS1vbmxpbmU=",
    "data-target": "reputation-ra",
    "data-model": "2"
  });
};
ReclameAqui.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (ReclameAqui);

/***/ }),

/***/ 66775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var SpotifyAdAnalytics = function SpotifyAdAnalytics(_ref) {
  var key = _ref["static"].key;
  var setupContent = "\n  (function(w, d){\n    var id='spdt-capture', n='script';\n    if (!d.getElementById(id)) {\n      w.spdt =\n        w.spdt ||\n        function() {\n          (w.spdt.q = w.spdt.q || []).push(arguments);\n        };\n      var e = d.createElement(n); e.id = id; e.async=1;\n      e.src = 'https://pixel.byspotify.com/ping.min.js';\n      var s = d.getElementsByTagName(n)[0];\n      s.parentNode.insertBefore(e, s);\n    }\n    w.spdt('conf', { key: '".concat(key, "' });\n  })(window, document);\n  ");
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: setupContent
    }
  });
};
SpotifyAdAnalytics.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (SpotifyAdAnalytics);

/***/ }),

/***/ 48517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Stewie = function Stewie(_ref) {
  var url = _ref["static"].url;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    async: true,
    fetchpriority: "low",
    src: url
  });
};
 false ? 0 : void 0;
Stewie.defaultProps = {
  "static": {
    url: 'https://wx.mlcdn.com.br/site/shared/stewie/stewie-3.1.0.min.js'
  }
};
Stewie.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = (Stewie);

/***/ }),

/***/ 62300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var TikTok = function TikTok(_ref) {
  var id = _ref["static"].id;
  var setupContent = "\n  !function (w, d, t) {\n    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i=\"https://analytics.tiktok.com/i18n/pixel/events.js\";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement(\"script\");o.type=\"text/javascript\",o.defer=true,o.fetchPriority=\"low\",o.src=i+\"?sdkid=\"+e+\"&lib=\"+t;var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(o,a);};\n    ttq.load('".concat(id, "');\n    ttq.page();\n  }(window, document, 'ttq');\n  ");
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: setupContent
    }
  });
};
TikTok.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (TikTok);

/***/ }),

/***/ 2159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Vwo_Vwo; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/Vwo/Vwo.js


var Vwo = function Vwo(_ref) {
  var id = _ref["static"].id;
  var setupContent = "\n    window._vwo_code=window._vwo_code || (function() {\n        var account_id=".concat(id, ",\n        version = 1.5,\n        settings_tolerance=2000,\n        library_tolerance=2500,\n        use_existing_jquery=false,\n        is_spa=1,\n        hide_element='body',\n        hide_element_style = '',\n        f=false,w=window,d=document,vwoCodeEl=d.querySelector('#vwoCode'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return'{'+hide_element_style+'}'},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement('script');t.fetchPriority='low';t.src=e;t.type='text/javascript';t.onerror=function(){_vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)\\s?(_vis_opt_exp_\\d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_\\d+_combi=(?:\\d+,?)+\\s*$/.test(t)){return''}return t}catch(e){return''}});var i=[];e.forEach(function(e){var t=e.match(/([\\d,]+)/g);t&&i.push(t.join('-'))});return i.join('|')},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;w.settings_timer=setTimeout(function(){_vwo_code.finish()},settings_tolerance);var e=d.currentScript,t=d.createElement('style'),i=e&&!e.async?hide_element?hide_element+'{'+hide_element_style+'}':'':code.lA=1,n=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');vwoCodeEl&&t.setAttribute('nonce',vwoCodeEl.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));n.appendChild(t);var o=this.getCombinationCookie();this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+ +is_spa+'&vn='+version+(o?'&c='+o:''));return settings_timer}};w._vwo_settings_timer = code.init();return code;}());\n    ");
  return react.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: setupContent
    }
  });
};
Vwo.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ var Vwo_Vwo = (Vwo);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/Vwo/index.js


/***/ }),

/***/ 7597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AllIn": function() { return /* reexport */ AllIn/* default */.Z; },
  "AllInNewsletter": function() { return /* reexport */ AllInNewsletter/* default */.Z; },
  "ApssFlyerBanner": function() { return /* reexport */ novisual_ApssFlyerBanner; },
  "Azion": function() { return /* reexport */ Azion/* default */.Z; },
  "Bing": function() { return /* reexport */ Bing/* default */.Z; },
  "CookieSecurity": function() { return /* reexport */ CookieSecurity["default"]; },
  "Criteo": function() { return /* reexport */ Criteo/* default */.Z; },
  "Datadog": function() { return /* reexport */ Datadog/* default */.Z; },
  "Ebit": function() { return /* reexport */ Ebit/* default */.Z; },
  "Favicon": function() { return /* reexport */ Favicon/* default */.Z; },
  "FundingChoices": function() { return /* reexport */ novisual_FundingChoices; },
  "GoogleTagManagerHead": function() { return /* reexport */ GoogleTagManagerHead/* default */.Z; },
  "GoogleTagManagerNoscript": function() { return /* reexport */ GoogleTagManagerNoscript/* default */.Z; },
  "Hotjar": function() { return /* reexport */ Hotjar/* default */.Z; },
  "JsonLd": function() { return /* reexport */ JsonLd/* default */.Z; },
  "Kwai": function() { return /* reexport */ novisual_Kwai; },
  "Preconnect": function() { return /* reexport */ Preconnect/* default */.Z; },
  "Preload": function() { return /* reexport */ novisual_Preload; },
  "RTBHouse": function() { return /* reexport */ RTBHouse/* default */.Z; },
  "Radware": function() { return /* reexport */ Radware/* default */.Z; },
  "ReclameAqui": function() { return /* reexport */ ReclameAqui/* default */.Z; },
  "SpotifyAdAnalytics": function() { return /* reexport */ SpotifyAdAnalytics/* default */.Z; },
  "Stewie": function() { return /* reexport */ Stewie/* default */.Z; },
  "TikTok": function() { return /* reexport */ TikTok/* default */.Z; },
  "Vwo": function() { return /* reexport */ Vwo/* default */.Z; }
});

// EXTERNAL MODULE: ../modules/build/esm/novisual/AllIn/index.js
var AllIn = __webpack_require__(82896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/ApssFlyerBanner/index.js


var ApssFlyerBanner = function ApssFlyerBanner(_ref) {
  var staticProps = _ref["static"];
  var bannerKey = staticProps.bannerKey;
  var content = "\n    !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src=\"https://websdk.appsflyer.com?\"+(c.length>0?\"st=\"+c.split(\",\").sort().join(\",\")+\"&\":\"\")+(i.length>0?\"af_id=\"+i:\"\"),p.parentNode.insertBefore(o,p)}(window,document,\"script\",0,\"AF\",\"banners\",{banners: {key: \"".concat(bannerKey, "\"}});\n    AF('banners', 'showBanner')\n  ");
  return react.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};
ApssFlyerBanner.ssr = true;
 false ? 0 : void 0;
/* harmony default export */ var novisual_ApssFlyerBanner = (ApssFlyerBanner);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Bing/index.js
var Bing = __webpack_require__(94842);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Criteo/index.js
var Criteo = __webpack_require__(63760);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Datadog/index.js
var Datadog = __webpack_require__(64002);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Ebit/index.js
var Ebit = __webpack_require__(53213);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/FundingChoices/index.js

var FundingChoices = function FundingChoices() {
  return react.createElement("script", {
    id: "fundingchoices",
    dangerouslySetInnerHTML: {
      __html: "(function(){ 'use strict';var g=function(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}},l=this||self,m=/^[w+/_-]+[=]{0,2}$/,p=null,q=function(){},r=function(a){var b=typeof a;if(\"object\"==b)if(a){if(a instanceof Array)return\"array\";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if(\"[object Window]\"==c)return\"object\";if(\"[object Array]\"==c||\"number\"==typeof a.length&&\"undefined\"!=typeof a.splice&&\"undefined\"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable(\"splice\"))return\"array\";\nif(\"[object Function]\"==c||\"undefined\"!=typeof a.call&&\"undefined\"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable(\"call\"))return\"function\"}else return\"null\";else if(\"function\"==b&&\"undefined\"==typeof a.call)return\"object\";return b},u=function(a,b){function c(){}c.prototype=b.prototype;a.prototype=new c;a.prototype.constructor=a};var v=function(a,b){Object.defineProperty(l,a,{configurable:!1,get:function(){return b},set:q})};var y=function(a,b){this.b=a===w&&b||\"\";this.a=x},x={},w={};var aa=function(a,b){a.src=b instanceof y&&b.constructor===y&&b.a===x?b.b:\"type_error:TrustedResourceUrl\";if(null===p)b:{b=l.document;if((b=b.querySelector&&b.querySelector(\"script[nonce]\"))&&(b=b.nonce||b.getAttribute(\"nonce\"))&&m.test(b)){p=b;break b}p=\"\"}b=p;b&&a.setAttribute(\"nonce\",b)};var z=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^+new Date).toString(36)};var A=function(a,b){b=String(b);\"application/xhtml+xml\"===a.contentType&&(b=b.toLowerCase());return a.createElement(b)},B=function(a){this.a=a||l.document||document};B.prototype.appendChild=function(a,b){a.appendChild(b)};var C=function(a,b,c,d,e,f){try{var k=a.a,h=A(a.a,\"SCRIPT\");h.async=!0;aa(h,b);k.head.appendChild(h);h.addEventListener(\"load\",function(){e();d&&k.head.removeChild(h)});h.addEventListener(\"error\",function(){0<c?C(a,b,c-1,d,e,f):(d&&k.head.removeChild(h),f())})}catch(n){f()}};var ba=l.atob(\"aHR0cHM6Ly93d3cuZ3N0YXRpYy5jb20vaW1hZ2VzL2ljb25zL21hdGVyaWFsL3N5c3RlbS8xeC93YXJuaW5nX2FtYmVyXzI0ZHAucG5n\"),ca=l.atob(\"WW91IGFyZSBzZWVpbmcgdGhpcyBtZXNzYWdlIGJlY2F1c2UgYWQgb3Igc2NyaXB0IGJsb2NraW5nIHNvZnR3YXJlIGlzIGludGVyZmVyaW5nIHdpdGggdGhpcyBwYWdlLg==\"),da=l.atob(\"RGlzYWJsZSBhbnkgYWQgb3Igc2NyaXB0IGJsb2NraW5nIHNvZnR3YXJlLCB0aGVuIHJlbG9hZCB0aGlzIHBhZ2Uu\"),ea=function(a,b,c){this.b=a;this.f=new B(this.b);this.a=null;this.c=[];this.g=!1;this.i=b;this.h=c},F=function(a){if(a.b.body&&!a.g){var b=\nfunction(){D(a);l.setTimeout(function(){return E(a,3)},50)};C(a.f,a.i,2,!0,function(){l[a.h]||b()},b);a.g=!0}},D=function(a){for(var b=G(1,5),c=0;c<b;c++){var d=H(a);a.b.body.appendChild(d);a.c.push(d)}b=H(a);b.style.bottom=\"0\";b.style.left=\"0\";b.style.position=\"fixed\";b.style.width=G(100,110).toString()+\"%\";b.style.zIndex=G(2147483544,2147483644).toString();b.style[\"background-color\"]=I(249,259,242,252,219,229);b.style[\"box-shadow\"]=\"0 0 12px #888\";b.style.color=I(0,10,0,10,0,10);b.style.display=\n\"flex\";b.style[\"justify-content\"]=\"center\";b.style[\"font-family\"]=\"Roboto, Arial\";c=H(a);c.style.width=G(80,85).toString()+\"%\";c.style.maxWidth=G(750,775).toString()+\"px\";c.style.margin=\"24px\";c.style.display=\"flex\";c.style[\"align-items\"]=\"flex-start\";c.style[\"justify-content\"]=\"center\";d=A(a.f.a,\"IMG\");d.className=z();d.src=ba;d.style.height=\"24px\";d.style.width=\"24px\";d.style[\"padding-right\"]=\"16px\";var e=H(a),f=H(a);f.style[\"font-weight\"]=\"bold\";f.textContent=ca;var k=H(a);k.textContent=da;J(a,\ne,f);J(a,e,k);J(a,c,d);J(a,c,e);J(a,b,c);a.a=b;a.b.body.appendChild(a.a);b=G(1,5);for(c=0;c<b;c++)d=H(a),a.b.body.appendChild(d),a.c.push(d)},J=function(a,b,c){for(var d=G(1,5),e=0;e<d;e++){var f=H(a);b.appendChild(f)}b.appendChild(c);c=G(1,5);for(d=0;d<c;d++)e=H(a),b.appendChild(e)},G=function(a,b){return Math.floor(a+Math.random()*(b-a))},I=function(a,b,c,d,e,f){return\"rgb(\"+G(Math.max(a,0),Math.min(b,255)).toString()+\",\"+G(Math.max(c,0),Math.min(d,255)).toString()+\",\"+G(Math.max(e,0),Math.min(f,\n255)).toString()+\")\"},H=function(a){a=A(a.f.a,\"DIV\");a.className=z();return a},E=function(a,b){0>=b||null!=a.a&&0!=a.a.offsetHeight&&0!=a.a.offsetWidth||(fa(a),D(a),l.setTimeout(function(){return E(a,b-1)},50))},fa=function(a){var b=a.c;var c=\"undefined\"!=typeof Symbol&&Symbol.iterator&&b[Symbol.iterator];b=c?c.call(b):{next:g(b)};for(c=b.next();!c.done;c=b.next())(c=c.value)&&c.parentNode&&c.parentNode.removeChild(c);a.c=[];(b=a.a)&&b.parentNode&&b.parentNode.removeChild(b);a.a=null};var ia=function(a,b,c,d,e){var f=ha(c),k=function(n){n.appendChild(f);l.setTimeout(function(){f?(0!==f.offsetHeight&&0!==f.offsetWidth?b():a(),f.parentNode&&f.parentNode.removeChild(f)):a()},d)},h=function(n){document.body?k(document.body):0<n?l.setTimeout(function(){h(n-1)},e):b()};h(3)},ha=function(a){var b=document.createElement(\"div\");b.className=a;b.style.width=\"1px\";b.style.height=\"1px\";b.style.position=\"absolute\";b.style.left=\"-10000px\";b.style.top=\"-10000px\";b.style.zIndex=\"-10000\";return b};var K={},L=null;var M=function(){},N=\"function\"==typeof Uint8Array,O=function(a,b){a.b=null;b||(b=[]);a.j=void 0;a.f=-1;a.a=b;a:{if(b=a.a.length){--b;var c=a.a[b];if(!(null===c||\"object\"!=typeof c||Array.isArray(c)||N&&c instanceof Uint8Array)){a.g=b-a.f;a.c=c;break a}}a.g=Number.MAX_VALUE}a.i={}},P=[],Q=function(a,b){if(b<a.g){b+=a.f;var c=a.a[b];return c===P?a.a[b]=[]:c}if(a.c)return c=a.c[b],c===P?a.c[b]=[]:c},R=function(a,b,c){a.b||(a.b={});if(!a.b[c]){var d=Q(a,c);d&&(a.b[c]=new b(d))}return a.b[c]};\nM.prototype.h=N?function(){var a=Uint8Array.prototype.toJSON;Uint8Array.prototype.toJSON=function(){var b;void 0===b&&(b=0);if(!L){L={};for(var c=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\".split(\"\"),d=[\"+/=\",\"+/\",\"-_=\",\"-_.\",\"-_\"],e=0;5>e;e++){var f=c.concat(d[e].split(\"\"));K[e]=f;for(var k=0;k<f.length;k++){var h=f[k];void 0===L[h]&&(L[h]=k)}}}b=K[b];c=[];for(d=0;d<this.length;d+=3){var n=this[d],t=(e=d+1<this.length)?this[d+1]:0;h=(f=d+2<this.length)?this[d+2]:0;k=n>>2;n=(n&\n3)<<4|t>>4;t=(t&15)<<2|h>>6;h&=63;f||(h=64,e||(t=64));c.push(b[k],b[n],b[t]||\"\",b[h]||\"\")}return c.join(\"\")};try{return JSON.stringify(this.a&&this.a,S)}finally{Uint8Array.prototype.toJSON=a}}:function(){return JSON.stringify(this.a&&this.a,S)};var S=function(a,b){return\"number\"!==typeof b||!isNaN(b)&&Infinity!==b&&-Infinity!==b?b:String(b)};M.prototype.toString=function(){return this.a.toString()};var T=function(a){O(this,a)};u(T,M);var U=function(a){O(this,a)};u(U,M);var ja=function(a,b){this.c=new B(a);var c=R(b,T,5);c=new y(w,Q(c,4)||\"\");this.b=new ea(a,c,Q(b,4));this.a=b},ka=function(a,b,c,d){b=new T(b?JSON.parse(b):null);b=new y(w,Q(b,4)||\"\");C(a.c,b,3,!1,c,function(){ia(function(){F(a.b);d(!1)},function(){d(!0)},Q(a.a,2),Q(a.a,3),Q(a.a,1))})};var la=function(a,b){V(a,\"internal_api_load_with_sb\",function(c,d,e){ka(b,c,d,e)});V(a,\"internal_api_sb\",function(){F(b.b)})},V=function(a,b,c){a=l.btoa(a+b);v(a,c)},W=function(a,b,c){for(var d=[],e=2;e<arguments.length;++e)d[e-2]=arguments[e];e=l.btoa(a+b);e=l[e];if(\"function\"==r(e))e.apply(null,d);else throw Error(\"API not exported.\");};var X=function(a){O(this,a)};u(X,M);var Y=function(a){this.h=window;this.a=a;this.b=Q(this.a,1);this.f=R(this.a,T,2);this.g=R(this.a,U,3);this.c=!1};Y.prototype.start=function(){ma();var a=new ja(this.h.document,this.g);la(this.b,a);na(this)};\nvar ma=function(){var a=function(){if(!l.frames.googlefcPresent)if(document.body){var b=document.createElement(\"iframe\");b.style.display=\"none\";b.style.width=\"0px\";b.style.height=\"0px\";b.style.border=\"none\";b.style.zIndex=\"-1000\";b.style.left=\"-1000px\";b.style.top=\"-1000px\";b.name=\"googlefcPresent\";document.body.appendChild(b)}else l.setTimeout(a,5)};a()},na=function(a){var b=Date.now();W(a.b,\"internal_api_load_with_sb\",a.f.h(),function(){var c;var d=a.b,e=l[l.btoa(d+\"loader_js\")];if(e){e=l.atob(e);\ne=parseInt(e,10);d=l.btoa(d+\"loader_js\").split(\".\");var f=l;d[0]in f||\"undefined\"==typeof f.execScript||f.execScript(\"var \"+d[0]);for(;d.length&&(c=d.shift());)d.length?f[c]&&f[c]!==Object.prototype[c]?f=f[c]:f=f[c]={}:f[c]=null;c=Math.abs(b-e);c=1728E5>c?0:c}else c=-1;0!=c&&(W(a.b,\"internal_api_sb\"),Z(a,Q(a.a,6)))},function(c){Z(a,c?Q(a.a,4):Q(a.a,5))})},Z=function(a,b){a.c||(a.c=!0,a=new l.XMLHttpRequest,a.open(\"GET\",b,!0),a.send())};(function(a,b){l[a]=function(c){for(var d=[],e=0;e<arguments.length;++e)d[e-0]=arguments[e];l[a]=q;b.apply(null,d)}})(\"__d3lUW8vwsKlB__\",function(a){\"function\"==typeof window.atob&&(a=window.atob(a),a=new X(a?JSON.parse(a):null),(new Y(a)).start())});}).call(this);\nwindow.__d3lUW8vwsKlB__(\"WyI3ZmNiNTU0N2M5OGYzMDBiIixbbnVsbCxudWxsLG51bGwsImh0dHBzOi8vZnVuZGluZ2Nob2ljZXNtZXNzYWdlcy5nb29nbGUuY29tL2YvQUdTS1d4VTdTYUI0cUJQSUNOZUNvLTlNWGxTM1RUUE01VFFqaERjYXlMdzkxcU44TGpBWW85WW5lbkRRTjVEaHhQWFpPVEhjcVpWemd5Z25kTmVUaENSYTlsb1x1MDAzZCJdCixbMjAsImRpdi1ncHQtYWQiLDEwMCwiTjJaallqVTFORGRqT1RobU16QXdZZ1x1MDAzZFx1MDAzZCIsW251bGwsbnVsbCxudWxsLCJodHRwczovL3d3dy5nc3RhdGljLmNvbS8wZW1uL2YvcC83ZmNiNTU0N2M5OGYzMDBiLmpzP3VzcXBcdTAwM2RDQWsiXQpdCiwiaHR0cHM6Ly9mdW5kaW5nY2hvaWNlc21lc3NhZ2VzLmdvb2dsZS5jb20vbC9BR1NLV3hVSlFuSE80aUMwQWRaaWFsLUFrbW9tdElBUGV4VUlYWjhXTGMyTFJUdC02VVg1a3o3SEpqUlRNMDE0QzFROHZxUVNfc09rNURaVkJKT3IwQkVKP2FiXHUwMDNkMSIsImh0dHBzOi8vZnVuZGluZ2Nob2ljZXNtZXNzYWdlcy5nb29nbGUuY29tL2wvQUdTS1d4WFFlV2VKLUh5OUl1Qzl2RXkzTlBpeC1tZnV3V1d3blc5aUpJd1NwbXpUZ1dja0F2QlIwYkkxZHdGTnkwU0stc0dvbWhvaGx5c1Y0cG9LS3RudD9hYlx1MDAzZDJcdTAwMjZzYmZcdTAwM2QxIiwiaHR0cHM6Ly9mdW5kaW5nY2hvaWNlc21lc3NhZ2VzLmdvb2dsZS5jb20vbC9BR1NLV3hXV0NJMDJYd29lZkxHcW1tNWV5N0NEY05GY0hSelk5VEJlYm1XRkRfTzZGLW5qcjU0UndhVVpkb1U4R0Z5UHh3WU5oTDdscVFJcEdYTlBYaUh4P3NiZlx1MDAzZDIiXQo=\");"
    }
  });
};
FundingChoices.ssr = true;
/* harmony default export */ var novisual_FundingChoices = (FundingChoices);
// EXTERNAL MODULE: ../modules/build/esm/novisual/GoogleTagManagerHead/index.js
var GoogleTagManagerHead = __webpack_require__(14499);
// EXTERNAL MODULE: ../modules/build/esm/novisual/GoogleTagManagerNoscript/index.js
var GoogleTagManagerNoscript = __webpack_require__(59462);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Hotjar/index.js
var Hotjar = __webpack_require__(61220);
// EXTERNAL MODULE: ../modules/build/esm/novisual/JsonLd/index.js + 1 modules
var JsonLd = __webpack_require__(70007);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Preconnect/index.js
var Preconnect = __webpack_require__(42438);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/Preload/index.js


var Preload = function Preload(_ref) {
  var _ref$static = _ref["static"],
    _ref$static2 = _ref$static === void 0 ? {} : _ref$static,
    _ref$static2$fonts = _ref$static2.fonts,
    fonts = _ref$static2$fonts === void 0 ? [] : _ref$static2$fonts;
  return react.createElement(react.Fragment, null, fonts.map(function (_ref2) {
    var path = _ref2.path,
      ext = _ref2.ext;
    return react.createElement("link", {
      key: "preload-".concat(path, ".").concat(ext),
      rel: "preload",
      as: "font",
      type: "font/".concat(ext),
      href: "".concat(path, ".").concat(ext),
      crossOrigin: "true",
      defer: true
    });
  }));
};
Preload.defaultProps = {
  "static": {
    fonts: []
  }
};
 false ? 0 : void 0;
Preload.ssr = true;
/* harmony default export */ var novisual_Preload = (Preload);
// EXTERNAL MODULE: ../modules/build/esm/novisual/ReclameAqui/index.js
var ReclameAqui = __webpack_require__(9039);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Stewie/index.js
var Stewie = __webpack_require__(48517);
// EXTERNAL MODULE: ../modules/build/esm/novisual/TikTok/index.js
var TikTok = __webpack_require__(62300);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/Kwai/index.js


var Kwai = function Kwai() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config;
  var _config$publicRuntime = config == null ? void 0 : config.publicRuntimeConfig,
    kwaiId = _config$publicRuntime.kwaiId;
  if (!kwaiId) return react.createElement(react.Fragment, null);
  var scriptKwai = "\n    !function(e,t){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=t():\"function\"==typeof define&&define.amd?define([],t):\"object\"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(e,\"__esModule\",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&\"object\"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,\"default\",{enumerable:!0,value:e}),2&t&&\"string\"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,\"a\",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p=\"\",n(n.s=0)}([function(e,t,n){\"use strict\";var r=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))};!function(e){var t=window;t.KwaiAnalyticsObject=e,t[e]=t[e]||[];var n=t[e];n.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\"];var o=function(e,t){e[t]=function(){var n=Array.from(arguments),o=r([t],n,!0);e.push(o)}};n.methods.forEach((function(e){o(n,e)})),n.instance=function(e){var t=n._i[e]||[];return n.methods.forEach((function(e){o(t,e)})),t},n.load=function(t,r){n._i=n._i||{},n._i[t]=[],n._i[t]._u=\"https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js\",n._t=n._t||{},n._t[t]=+new Date,n._o=n._o||{},n._o[t]=r||{};var o=document.createElement(\"script\");o.type=\"text/javascript\",o.async=!0,o.fetchPriority=\"low\",o.src=\"https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js?sdkid=\"+t+\"&lib=\"+e;var i=document.getElementsByTagName(\"script\")[0];i.parentNode.insertBefore(o,i)}}(\"kwaiq\")}])}));\n    kwaiq.load('".concat(kwaiId, "');\n    kwaiq.page();\n  ");
  return react.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: scriptKwai
    }
  });
};
Kwai.ssr = true;
 false ? 0 : void 0;
Kwai.defaultProps = {
  config: {}
};
/* harmony default export */ var novisual_Kwai = (Kwai);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Favicon/index.js
var Favicon = __webpack_require__(80995);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Radware/index.js
var Radware = __webpack_require__(65027);
// EXTERNAL MODULE: ../modules/build/esm/novisual/RTBHouse/index.js
var RTBHouse = __webpack_require__(50682);
// EXTERNAL MODULE: ../modules/build/esm/novisual/AllInNewsletter/index.js
var AllInNewsletter = __webpack_require__(64365);
// EXTERNAL MODULE: ../modules/build/esm/novisual/CookieSecurity/index.js
var CookieSecurity = __webpack_require__(45875);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Vwo/index.js + 1 modules
var Vwo = __webpack_require__(2159);
// EXTERNAL MODULE: ../modules/build/esm/novisual/SpotifyAdAnalytics/index.js
var SpotifyAdAnalytics = __webpack_require__(66775);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Azion/index.js
var Azion = __webpack_require__(14286);
;// CONCATENATED MODULE: ../modules/build/esm/novisual/index.js


























/***/ })

}]);